import client from './client';

export const getEmailTrackingsApi = ({ limit, offset }) =>
  client().get('/email-tracking', {
    params: {
      $skip: offset,
      $limit: limit,
    },
  });
